import { NotificationContext } from './../../../context/NotificationContext'
import { useContext } from 'react'

const typeClasses = {
  success:
    'bg-emerald-600/95 text-emerald-50 border border-emerald-500/70 shadow-emerald-500/30',
  error:
    'bg-rose-600/95 text-rose-50 border border-rose-500/70 shadow-rose-500/30',
  info:
    'bg-slate-900/95 text-slate-50 border border-slate-700/80 shadow-slate-900/40',
}

const NotificationToast = () => {
  const { notifications = [] } = useContext(NotificationContext)

  if (!notifications.length) return null

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-3 max-w-sm w-full">
      {notifications.map((n) => {
        const base =
          n.type === 'success'
            ? typeClasses.success
            : n.type === 'error'
            ? typeClasses.error
            : typeClasses.info

        return (
          <div
            key={n.id}
            className={`${base} px-4 py-3 rounded-xl text-sm font-medium shadow-lg backdrop-blur-md animate-slide-up`}
          >
            {n.message}
          </div>
        )
      })}
    </div>
  )
}

export default NotificationToast